export default {"src":"/_next/static/media/logo_vertical.92a89271.svg","height":135,"width":292,"blurWidth":0,"blurHeight":0};